export enum FieldType {
  Numeric = 1,
  String = 2,
  Boolean = 3,
  Date = 4,
  Array = 5,
  Collection = 6,
  DateTime = 5
}
